import React, { useState } from "react";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import "./WhatsappReaction.scss";
import BorderButton from "../../../Reuseable/BorderButton/BorderButton";
import WhatsappConversationModal from "../WhatsappConversationModal/WhatsappConversationModal";
const WhatsappReaction = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const dataSource = [
    {
      key: "1",
      id: "Apr 23, 2025 – 6:17 PM",
      name: "Your account is still unpaid. Continued non-payment may result in doorstep recovery visits. We urge you to respond immediately to avoid escalations.",
      status: "Delivered",
    },
    {
      key: "2",
      id: "Apr 23, 2025 – 6:17 PM",
      name: "EMI holidays is now available under special hardship conditions. You can pause payments for up to 60 days. Reply PAUSE to activate or contact your case agent.",
      status: "Not Delivered",
    },
    {
      key: "3",
      id: "Apr 23, 2025 – 6:17 PM",
      name: "Based on your profile, you may qualify for a grace period. We want to help you resolve this without penalties. Please respond today.",
      status: "Not Seen",
    },
    {
      key: "4",
      id: "Apr 23, 2025 – 6:17 PM",
      name: "Struggling to repay the full amount? Let’s restructure your loan into easier EMIs. Call your case manager or reply with PLAN to explore customized options.",
      status: "Seen",
    },
    {
      key: "5",
      id: "Apr 23, 2025 – 6:17 PM",
      name: "Your auto-debit transaction failed today. Please update your payment method or use the link sent earlier to make a manual payment. Call us for help if needed.",
      status: "Delivered",
    },
    {
      key: "6",
      id: "Apr 23, 2025 – 6:17 PM",
      name: "This is your final reminder. If no action is taken today, your account will be reported to credit bureaus. You may face future loan eligibility. Call now to pay down this.",
      status: "Delivered",
    },
    {
      key: "7",
      id: "Apr 23, 2025 – 6:17 PM",
      name: "Your account is eligible for a part-payment option. Start with just ₹50,000 and settle the rest in 2 months. Reply START or call your agent now to activate this plan.",
      status: "Delivered",
    },
    {
      key: "8",
      id: "Apr 23, 2025 – 6:17 PM",
      name: "We noticed you haven’t responded. If you’re facing difficulty, we’re here to help. Let’s discuss a payment plan that works for you. Contact our helpline or reply to this SMS.",
      status: "Delivered",
    },
    {
      key: "9",
      id: "Apr 23, 2025 – 6:17 PM",
      name: "Important: A one-time settlement offer of ₹1,90,000 is available for your account, valid for 48 hours. Don’t miss this chance to close your case. Reply YES or contact your assigned agent today.",
      status: "Not Seen",
    },
    {
      key: "10",
      id: "Apr 23, 2025 – 6:17 PM",
      name: "Dear Pradeep, your personal loan is overdue by ₹2,79,157. Please clear your dues immediately to avoid legal consequences and further credit damage. Call 1800-000-000 for support.",
      status: "Seen",
    },
  ];
  const columns = [
    {
      title: "Date & Time",
      dataIndex: "id",
      key: "id",
      render: (name) => <div style={{ width: "282px" }}>{name}</div>,
    },
    {
      title: "Message Content",
      dataIndex: "name",
      key: "name",
      render: (name) => <div style={{ width: "600px" }}>{name}</div>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <div
          className={`statusTag ${
            status === "Delivered"
              ? "delivered"
              : status === "Not Delivered"
              ? "notDelivered"
              : status === "Seen"
              ? "seen"
              : status === "Not Seen"
              ? "notSeen"
              : ""
          }`}
        >
          {status}
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (action) => (
        <BorderButton
          text="View Conversation"
          onClick={() => setIsModalOpen(true)}
        />
      ),
    },
  ];
  return (
    <div className="WhatsappReactionMain">
      <ReusableTable
        columns={columns}
        dataSource={dataSource}
        rowKey="key"
        bordered
        pageSize={10}
        CurrentPageNo={1}
        totalItems={18}
      />
      <WhatsappConversationModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default WhatsappReaction;
